var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseArrowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6812 2.08923L28.1806 7.78997L24.322 3.22148V15.2794H36.3087L31.7482 11.3654L37.4347 5.85086L33.6812 2.08923Z",
    fill: "#AAA9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0077 35.4758L15.5084 29.7751L19.3669 34.3436V22.2857H7.3803L11.9407 26.1997L6.25426 31.7142L10.0077 35.4758Z",
    fill: "#AAA9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseArrowsIcon);
export default __webpack_public_path__ + "static/media/CloseArrowsIcon.c04b581bc4c2751320cde3bbbfc96488.svg";
export { ForwardRef as ReactComponent };